export default __webpack_public_path__ + "static/media/icbc.28beb61a.svg";